import { render, staticRenderFns } from "./UsersEditor.vue?vue&type=template&id=1803db20"
import script from "./UsersEditor.vue?vue&type=script&lang=ts"
export * from "./UsersEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports